<div class="incoming-call">
  <div class="w-full flex justify-end">
    <span class="cursor-pointer" (click)="reject()">
      <img class="h-[40px] w-[40px]" src="assets/images/x-icon-202020.svg" />
    </span>
  </div>
  <div class="incoming-call-content">
    <div class="img">
         <nz-avatar
          [nzSize]="80" [style.backgroundColor]="avatarBg"
          [nzSrc]="avatarUrl"
          [nzText]="displayName().charAt(0).toUpperCase()"
          >
        </nz-avatar>
    </div>
    <div class="information-call">
      <div class="call-name">{{ displayName() }}</div>
      <div class="now-call">Đang gọi cho bạn</div>
    </div>
    <div class="help-text">
      <img style="padding-bottom: 3px;" src="assets/images/icon-lock.svg">
      <span class="span-help-text">Đã được mã hóa đầu cuối</span>
    </div>
  </div>
  <div class="incoming-call-footer">
    <div class="incoming-call-footer-content">
      <div class="action cursor-pointer">
        <img style="padding-bottom: 3px;" src="assets/images/icon-deny-call.svg" (click)="reject()">
        <span class="text">Từ chối</span>
      </div>
      <div class="action cursor-pointer">
        <img style="padding-bottom: 3px;" [src]="isWaiting ? 'assets/images/switch-call-icon.svg' : this.data?.call?.type === 'video' ? 'assets/images/icon-accept-call-video.svg' : 'assets/images/icon-accept-call.svg'" (click)="accept()">
        <span class="text">{{ isWaiting ? 'Kết thúc và Trả lời' : 'Chấp nhận'}}</span>
      </div>
    </div>
  </div>
</div>
